import { getValue } from "../../../common/getValue";
import { formatPrice } from "../../../common/formatPrice";

export function PUSHCART_PRODUCT_REQUEST(state) {
  state;
  state.pushcartProducts = {
    ...state.pushcartProducts,
    isLoading: true
  };
}
export function PUSHCART_PRODUCT_SUCCESS(state, payload) {
  const data = [];
  payload.data.pushcart_product.map(item => {
    data.push({
      id: item.id || "-",
      image: getValue(item, 'image', "-"),
      name: getValue(item, 'name', "-"),
      price: `Rp. ${formatPrice(getValue(item, 'price', 0))}`,
      discountType: getValue(item, 'discountType', "-"),
      discount: getValue(item, 'discount', "-"),
      status: getValue(item, 'status', false),
    });
    return item;
  });
  state;
  state.pushcartProducts = {
    data: data,
    count: payload.data.count,
    status: payload.status,
    isLoading: false
  };
}
export function PUSHCART_PRODUCT_ERROR(state, payload) {
  state;
  state.pushcartProducts = {
    ...state.pushcartProducts,
    error: true,
    errorMessage: payload,
    isLoading: false
  }
}
